import type { TableActionSpec } from '@/@vxapp/@Types/ServiceMetadata'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { BusinessField } from '@/@vxapp/@Enums/PHP/ServicesV2/Businesses/DataProviders/BusinessField'

export const BusinessesTableActions = [
  {
    id: 'edit',
    title: 'Edit',
    tooltip: 'Edit Business',
    icon: 'tabler-pencil',
    color: 'primary',
    disabled: false,
    hidden: false,
    emit: 'edit',
  },
  {
    id: 'preview',
    title: 'Preview',
    tooltip: 'View Business',
    icon: 'tabler-eye',
    color: 'primary',
    disabled: false,
    hidden: false,
    route: {
      name: PageMeta.Businesses.preview.name || '',
      paramKey: 'guid',
      itemKey: BusinessField.DB_IDENTIFIER,
    },
    emit: 'preview',
  },
] as const satisfies readonly TableActionSpec[]
